import { FormatDateTime } from './dateTime';
import { FormatNumbers } from './number';
import { FormatString } from './string';

export const Format = { ...FormatDateTime, ...FormatNumbers, ...FormatString };
